"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInlineAlertBehavior = void 0;
var helpers_1 = require("../../../common/helpers");
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_inline_alert_constants_1 = require("./bc-inline-alert-constants");
var bc_inline_alert_constants_2 = require("./bc-inline-alert-constants");
var bc_inline_alert_constants_3 = require("./bc-inline-alert-constants");
var bc_inline_alert_constants_4 = require("./bc-inline-alert-constants");
var bc_inline_alert_constants_5 = require("./bc-inline-alert-constants");
var bc_inline_alert_constants_6 = require("./bc-inline-alert-constants");
var bc_inline_alert_constants_7 = require("./bc-inline-alert-constants");
var bc_inline_alert_constants_8 = require("./bc-inline-alert-constants");
var bc_inline_alert_constants_9 = require("./bc-inline-alert-constants");
var bc_inline_alert_constants_10 = require("./bc-inline-alert-constants");
var BcInlineAlertBehavior = (function (_super) {
    __extends(BcInlineAlertBehavior, _super);
    function BcInlineAlertBehavior() {
        var _this = _super.call(this) || this;
        _this.timeOut = 0;
        return _this;
    }
    BcInlineAlertBehavior.setUpAll = function () {
        var InlineAlertElements = Array.from(document.querySelectorAll(".".concat(bc_inline_alert_constants_1.BC_NEW_ALERT_INLINE)));
        var elements = [];
        for (var _i = 0, InlineAlertElements_1 = InlineAlertElements; _i < InlineAlertElements_1.length; _i++) {
            var element = InlineAlertElements_1[_i];
            var bcInlineAlertBehavior = new BcInlineAlertBehavior();
            bcInlineAlertBehavior.setElement(element);
            bcInlineAlertBehavior.setUp();
            elements.push(bcInlineAlertBehavior);
        }
        return elements;
    };
    BcInlineAlertBehavior.prototype._setUp = function () {
        this.setCloseButton();
        this.setListeners();
    };
    BcInlineAlertBehavior.prototype.setCloseButton = function () {
        this.bcInlineAlertCloseButton = this.mySelf.querySelector(".".concat(bc_inline_alert_constants_3.BC_ALERT_INLINE_CLOSE));
    };
    BcInlineAlertBehavior.prototype.setListeners = function () {
        var _this = this;
        var _a;
        (_a = this.bcInlineAlertCloseButton) === null || _a === void 0 ? void 0 : _a.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.close();
        });
        this.hideAlertAfterCloseAnimation();
    };
    BcInlineAlertBehavior.prototype.close = function () {
        if (this.mySelf.classList.contains(bc_inline_alert_constants_2.BC_ALERT_INLINE_ACTIVE) ||
            this.mySelf.classList.contains(bc_inline_alert_constants_5.BC_ALERT_INLINE_DISMISSIBLE)) {
            this.mySelf.classList.add(bc_inline_alert_constants_4.BC_ALERT_INLINE_CLOSING);
        }
    };
    BcInlineAlertBehavior.prototype.onClose = function (fn) {
        this.onCloseFunction = fn;
    };
    BcInlineAlertBehavior.prototype.hideAlertAfterCloseAnimation = function () {
        var _this = this;
        this.mySelf.addEventListener(bc_inline_alert_constants_10.BC_ALERT_INLINE_ANIMATIONEND, function (ev) {
            var _a, _b, _c;
            if (ev.animationName === common_constants_1.BcCommonConstants.FADE_OUT_OPACITY ||
                ev.animationName === common_constants_1.BcCommonConstants.SLIDE_UP_REVERSE) {
                _this.mySelf.classList.remove(bc_inline_alert_constants_4.BC_ALERT_INLINE_CLOSING);
                _this.mySelf.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, common_constants_1.BcCommonConstants.TRUE.toString());
                (_b = (_a = _this.bcInlineAlertCloseButton) === null || _a === void 0 ? void 0 : _a.querySelector(common_constants_1.BcCommonConstants.BUTTON_TAG)) === null || _b === void 0 ? void 0 : _b.toggleAttribute(common_constants_1.BcCommonConstants.DISABLED, common_constants_1.BcCommonConstants.TRUE);
                (0, helpers_1.replaceClass)(_this.mySelf, bc_inline_alert_constants_2.BC_ALERT_INLINE_ACTIVE, bc_inline_alert_constants_1.BC_NEW_ALERT_INLINE);
                (_c = _this.onCloseFunction) === null || _c === void 0 ? void 0 : _c.call(_this);
            }
        });
    };
    BcInlineAlertBehavior.prototype.open = function () {
        var _this = this;
        var _a, _b;
        (0, helpers_1.replaceClass)(this.mySelf, bc_inline_alert_constants_1.BC_NEW_ALERT_INLINE, bc_inline_alert_constants_2.BC_ALERT_INLINE_ACTIVE);
        this.mySelf.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, common_constants_1.BcCommonConstants.FALSE.toString());
        (_b = (_a = this.bcInlineAlertCloseButton) === null || _a === void 0 ? void 0 : _a.querySelector(common_constants_1.BcCommonConstants.BUTTON_TAG)) === null || _b === void 0 ? void 0 : _b.toggleAttribute(common_constants_1.BcCommonConstants.DISABLED, common_constants_1.BcCommonConstants.FALSE);
        if (this.timeOut != 0) {
            this.mySelf.setAttribute(bc_inline_alert_constants_9.BC_ALERT_INLINE_ROLE, bc_inline_alert_constants_8.BC_ALERT_INLINE_ALERT);
            setTimeout(function () {
                _this.close();
            }, this.timeOut);
        }
    };
    BcInlineAlertBehavior.prototype.setTimeOut = function (time) {
        if (time >= bc_inline_alert_constants_7.BC_ALERT_INLINE_MIN_TIME_DELAY_INLINE && time <= bc_inline_alert_constants_6.BC_ALERT_INLINE_MAX_TIME_DELAY_INLINE) {
            this.timeOut = time;
        }
        else if (time > bc_inline_alert_constants_6.BC_ALERT_INLINE_MAX_TIME_DELAY_INLINE) {
            this.timeOut = bc_inline_alert_constants_6.BC_ALERT_INLINE_MAX_TIME_DELAY_INLINE;
        }
        else if (time > 0 && time < bc_inline_alert_constants_7.BC_ALERT_INLINE_MIN_TIME_DELAY_INLINE) {
            this.timeOut = bc_inline_alert_constants_7.BC_ALERT_INLINE_MIN_TIME_DELAY_INLINE;
        }
        else {
            this.timeOut = 0;
        }
    };
    return BcInlineAlertBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcInlineAlertBehavior = BcInlineAlertBehavior;
